<template>
  <div id="emailmodal" class="modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn btn-icon btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ bodyText }}</p>
          <span class="email">{{ computedEmail }}</span>
        </div>
        <div class="modal-footer">
          <div class="button-container">
            <button type="button" class="btn btn-secondary" @click="onEdit" data-bs-dismiss="modal">{{ editButtonText }}</button>
            <button type="button" class="btn btn-primary" @click="onSend" data-bs-dismiss="modal">{{ sendButtonText }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EmailModal',
    props: {
      title: { type: String, default: 'Controleer je e-mailadres' },
      bodyText: { type: String, default: 'Is onderstaande e-mailadres correct?' },
      email: { type: String },
      editButtonText: { type: String, default: 'Aanpassen' },
      sendButtonText: { type: String, default: 'Verzenden' },
      visible: { type: Boolean, default: false },
    },
    computed: {
      // Computed property to return either the provided email or the default one
      computedEmail() {
        return this.email && this.email.trim() !== '' ? this.email : 'Er is geen e-mailadres ingevuld';
      }
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      onEdit() {
        this.$emit('edit');
      },
      onSend() {
        this.$emit('send');
      },
    },
  };
</script>

<style>
/* Voeg hier je CSS-styling toe */
.modal {
  display: block; /* Zorg ervoor dat het zichtbaar is wanneer actief */
}
</style>